import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card } from 'react-bootstrap';
import './Services.css'

const ServiceDetails = ({service}) => {
    const {name,title,icon,details} = service;
    return (
        <div 
         className="col-md-4" 
         data-aos='fade-up'
         data-aos-duration='700'
         data-aos-delay='600'
         >
            <div className="service-card text-center  animate__animated animate__fadeInUp animate__delay-3s">   
                    <FontAwesomeIcon className="icon" icon={icon}/>
                        <Card.Title><span>{name}</span> {title}</Card.Title>
                        <Card.Text>{details}</Card.Text>
           </div>
        </div>
    );
};

export default ServiceDetails;